import React from "react";
import favicon from "../../static/favicon.svg";
import { mediaStyles } from "./Media";
import { getSrc } from "gatsby-plugin-image";
import { Script } from "gatsby";

function SEO({ location, params, data, pageContext, children }) {
  const { site, contentfulContentPage } = data;

  const {
    pageTitle,
    metaDescription,
    metaKeywords,
    ogtitle,
    ogdescription,
    ogurl,
    ogimage,
    ogtype,
  } = contentfulContentPage;

  const { siteMetadata } = site;

  return (
    <>
      <title lang="en">{pageTitle}</title>
      <link
        rel="canonical"
        href={`${siteMetadata.siteUrl}${location.pathname}`}
      />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta property="og:description" content={ogdescription} />
      <meta property="og:title" content={ogtitle} />
      <meta property="og:url" content={ogurl} />
      <meta property="og:image" content={getSrc(ogimage)} />
      <meta property="og:type" content={ogtype} />
      <Script
        id="termly-resource-blocker-script"
        type="text/javascript"
        src="https://app.termly.io/resource-blocker/1d5c37e5-1476-4c2a-a35c-73f38ace6e0f?autoBlock=on"
      />
      <link rel="stylesheet" href="https://use.typekit.net/ayk0huu.css" />
      <style>{mediaStyles}</style>
      <script type="application/ld+json">
        {`
        {
          "@context":"http://schema.org",
          "@type":"Organization",
          "name":"Build With Assembly",
          "legalName":"Assembly Inc.",
          "alternateName":[
              "BuildWithAssembly",
              "Assembly"
          ],
          "url":"https://assemblyhq.com/",
          "logo":"https://media-exp1.licdn.com/dms/image/C4E0BAQE9PJUoksQy1Q/company-logo_200_200/0/1619218546795?e=1654128000&v=beta&t=xHhqzV-3BLePeoV9BlvcwOUiRmT7Uhxo0Nz3-yxwvQQ",
          "image":"https://assemblyhq.com/static/mountain-00a666da4b81e0d4dd46ff03b1c74dbf.jpg",
          "email":"hello@assemblyhq.com",
          "telephone":"416-342-5649",
          "address":"107 Atlantic Ave #300, Toronto, ON M6K 1Y2",
          "sameAs":[
              "https://www.instagram.com/assemblyinc/",
              "https://www.facebook.com/assemblyhq/",
              "https://twitter.com/_assemblyhq",
              "https://www.linkedin.com/company/assemblyinc/"
          ],
          "description":"Build With Assembly is a software engineering firm that helps leading organizations champion rapid digital transformation.",
          "founder":[
              {
                "@type":"person",
                "name":"John Wilk",
                "jobTitle":"CEO, Partner",
                "url":"https://www.linkedin.com/in/johnkwilk/"
              },
              {
                "@type":"person",
                "name":"Chris Smillie",
                "jobTitle":"CTO, Partner",
                "url":"https://www.linkedin.com/in/chris-smillie/"
              }
          ],
          "foundingDate":"2006",
          "foundingLocation":"Toronto, Ontario, Canada",
          "makesOffer":[
              "Experience & Product Engineering",
              "Application Modernization",
              "Agile Software Development",
              "Cloud Infrastructure & Digital Platforms",
              "Cloud Migration",
              "Azure Cloud Managed Services",
              "Application & Cloud Managed Services",
              "Web Development"
          ],
          "disambiguatingDescription":"Build With Assembly is a software engineering firm based on in Toronto, Canada. It partners with leading organizations across North America to modernize, build, and operate cloud-native software solutions."
        }
      `}
      </script>
      {/* <!-- Google Tag Manager --> */}
      <script>
        {` (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id=GTM-P9MQ6WV'+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-P9MQ6WV');
         `}
      </script>
      {/* <!-- End Google Tag Manager --> */}
      <link id="favicon" rel="icon" href={favicon} />
      {children}
    </>
  );
}

export default SEO;
